export default "__VITE_ASSET__e3bf3bdc__"